<template>
  <div class="box">
    <h3>Ad Details</h3>

    <div class="form-group">
      <label class="tit">Ad name <span class="required">*</span></label>
      <input type="text" v-model="adName" placeholder="Enter ad name" />
    </div>

    <div class="form-group">
      <label class="tit">Ad identity <span class="required">*</span></label>
      <PlatformPage
        ref="platformPage"
        class="w-100"
        v-model:identity="identity"
      />
    </div>

    <div class="form-group">
      <label class="tit">Ad format <span class="required">*</span></label>
      <div class="ad-format w-100">
        <div class="format-card selected">
          <SingleVedio />
          <div>
            <strong>Single Video</strong>
            <p>Create ad with a single video post.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group switch">
      <label class="tit">Status <span class="required">*</span></label>
      <input type="checkbox" id="status" v-model="status" />
      <label for="status" class="toggle-label">
        <span class="circle"></span>
      </label>
      <span class="status-text">Active</span>
    </div>
  </div>
</template>

<script>
import SingleVedio from "../icons/SingleVedio.vue";
import { useSuperAddStore } from "@/store/superAddStore";
import PlatformPage from "./PlatformPage.vue";

export default {
  name: "AdDetailsBox",
  components: { SingleVedio, PlatformPage },

  data() {
    return {
      identityoptions: ["Meta Page", "Snapchat Account", "TikTok Account"],
    };
  },

  computed: {
    store() {
      return useSuperAddStore();
    },

    // Bind directly to adCreativeData in the store
    adName: {
      get() {
        return this.store.adCreativeData.adName;
      },
      set(val) {
        this.store.adCreativeData.adName = val;
      },
    },
    identity: {
      get() {
        return this.store.adCreativeData.identity;
      },
      set(val) {
        this.store.adCreativeData.identity = val;
      },
    },
    status: {
      get() {
        return this.store.adCreativeData.status;
      },
      set(val) {
        this.store.adCreativeData.status = val;
      },
    },
  },

  mounted() {
    // Set default format in store
    this.store.adCreativeData.format = "Single Video";
  },

  methods: {
    validate() {
      const errors = [];

      if (!this.adName?.trim()) errors.push("Ad name is required.");

      // تحقق من كل الهويات لكل منصة
      const platformPage = this.$refs.platformPage;

      if (
        platformPage &&
        typeof platformPage.getSelectedAccounts === "function"
      ) {
        const selectedAccounts = platformPage.getSelectedAccounts();
        const platforms = platformPage.platforms;

        const missing = platforms.filter((p) => !selectedAccounts[p.name]);

        if (missing.length > 0) {
          const names = missing.map((p) => p.display).join(", ");
          errors.push(`Please select identity for all platforms`);
        }
      } else {
        errors.push("Platform identities are not loaded yet.");
      }

      return errors;
    },
    getData() {
      return {
        adName: this.adName,
        identity: this.identity,
        status: this.status,
        format: this.store.adCreativeData.format,
      };
    },
  },
};
</script>

<style scoped>
.box {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
  flex: 1;
  min-width: 300px;
}

h3 {
  margin-bottom: 1.5rem;
  font-size: 18px;
  font-weight: 600;
}

.form-group {
  margin-bottom: 1.25rem;
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  align-items: center;
}

input[type="text"],
select {
  padding: 0.65rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
}

.required {
  color: red;
}

.ad-format .format-card {
  display: flex;
  gap: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  background: #f5f5f5;
  align-items: center;
}

.format-card.selected {
  background: white;
}

.icon {
  width: 40px;
  height: 40px;
}

.switch {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-direction: row;
}

input[type="checkbox"] {
  display: none;
}

.toggle-label {
  width: 40px;
  height: 22px;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

input[type="checkbox"]:checked + .toggle-label {
  background: #237276;
}

.toggle-label .circle {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 2px;
  left: 2px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

input[type="checkbox"]:checked + .toggle-label .circle {
  transform: translateX(18px);
}
.tit {
  min-width: 14rem;
}
::v-deep(.v-field__outline) {
  display: none !important;
}
::v-deep(.v-input--horizontal) {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.25rem;
}
::v-deep(.v-text-field .v-field__outline) {
  display: none !important;
}
::v-deep(.v-field__field) {
  min-width: 5rem;
}
</style>
